import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProjectCorrespondence from '../ProjectCorrespondence';
import { useProjectData } from '../ProjectDataContext';

function CorrespondencePanel({ active }) {
  const {
    project,
    projectNumber,
    projectName,
    tasks,
    deliverables,
    mailNotities,
  } = useProjectData();
  const [searchParams, setSearchParams] = useSearchParams();

  // "✓ Notitie" → de Notes-drawer open, met die notitie in beeld (NotesPanel scrolt ernaar).
  const openNotitie = useCallback((noteId) => {
    const next = new URLSearchParams(searchParams);
    next.set('paneel', 'notes');
    if (noteId) next.set('notitie', noteId);
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <>
        <ProjectCorrespondence
          active={active}
          projectId={project?.id}
          projectNumber={projectNumber}
          projectName={projectName}
          tasks={tasks}
          deliverables={deliverables}
          mailNotities={mailNotities}
          onOpenNotitie={openNotitie}
          contactEmail={(() => {
            const em = project?.fields?.emailCP || [];
            return Array.isArray(em) ? (em[0] || '') : String(em || '');
          })()}
        />
    </>
  );
}

export default CorrespondencePanel;
